import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=423c0161&scoped=true"
import script from "./StartPage.vue?vue&type=script&lang=js"
export * from "./StartPage.vue?vue&type=script&lang=js"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=423c0161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c0161",
  null
  
)

export default component.exports